module.exports = __webpack_public_path__ + "static/media/sizeIcon.676256ca.png";